import React from 'react';

const HowAssessmentWorksSection = () => (
  <div className="py-12 bg-white dark:bg-gray-900">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-6">
          How Our Assessment Works
        </h2>
        <p className="text-lg text-gray-600 dark:text-gray-400 max-w-4xl mx-auto">
          Our proprietary algorithm analyses your operational data against proven energy
          efficiency measures to give you a clear, actionable assessment.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Industry-Specific */}
        <div className="text-center">
          <div className="bg-gray-100 dark:bg-gray-800 rounded-3xl p-8 mb-6 mx-auto w-48 h-48 flex items-center justify-center">
            <div className="bg-emerald-600 dark:bg-emerald-700 rounded-2xl p-4 w-24 h-24 flex items-center justify-center">
              <svg
                className="w-12 h-12 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                />
              </svg>
            </div>
          </div>
          <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
            Industry-Specific
          </h3>
          <p className="text-gray-600 dark:text-gray-400">
            Tailored questions designed for your specific industrial sector.
          </p>
        </div>

        {/* Data-Driven Insights */}
        <div className="text-center">
          <div className="bg-gray-100 dark:bg-gray-800 rounded-3xl p-8 mb-6 mx-auto w-48 h-48 flex items-center justify-center">
            <div className="bg-emerald-600 dark:bg-emerald-700 rounded-2xl p-4 w-24 h-24 flex items-center justify-center">
              <svg
                className="w-12 h-12 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
            </div>
          </div>
          <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
            Data-Driven Insights
          </h3>
          <p className="text-gray-600 dark:text-gray-400">
            Benchmarked against thousands of real-world industrial facilities.
          </p>
        </div>

        {/* Quantified Savings */}
        <div className="text-center">
          <div className="bg-gray-100 dark:bg-gray-800 rounded-3xl p-8 mb-6 mx-auto w-48 h-48 flex items-center justify-center">
            <div className="bg-emerald-600 dark:bg-emerald-700 rounded-2xl p-4 w-24 h-24 flex items-center justify-center">
              <svg
                className="w-12 h-12 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>
          <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
            Quantified Savings
          </h3>
          <p className="text-gray-600 dark:text-gray-400">
            Get precise estimates of potential annual energy cost reductions.
          </p>
        </div>

        {/* Quick & Easy */}
        <div className="text-center">
          <div className="bg-gray-100 dark:bg-gray-800 rounded-3xl p-8 mb-6 mx-auto w-48 h-48 flex items-center justify-center">
            <div className="bg-emerald-600 dark:bg-emerald-700 rounded-2xl p-4 w-24 h-24 flex items-center justify-center">
              <svg
                className="w-12 h-12 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>
          <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Quick & Easy</h3>
          <p className="text-gray-600 dark:text-gray-400">
            Complete your energy evaluation in just 15-20 minutes.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default HowAssessmentWorksSection;


